export default "__VITE_ASSET__f17c8d1c__"